import {
  API_AUTH_CERTS,
  API_AUTH_CERTS_FETCH,
  API_AUTH_CERTS_RESET,
  API_AUTH_DUO_ERROR,
  API_AUTH_DUO_FETCH,
  API_AUTH_DUO_SUCCESS,
  API_AUTH_ERROR,
  API_AUTH_FETCH,
  API_AUTH_RESET,
  API_AUTH_SERVER,
  API_AUTH_SET_DUO,
  API_AUTH_SUCCESS,
  API_CAMERAS_ERROR,
  API_CAMERAS_FETCH,
  API_CAMERAS_SUCCESS,
  API_CANCEL_AUTH,
  API_LAYOUTS_ERROR,
  API_LAYOUTS_FETCH,
  API_LAYOUTS_SUCCESS,
  API_MAPS_SUCCESS,
  API_SERVICE_TYPE,
  API_SESSION_TOKEN_IS_OVER,
  API_SET_BOOKMARKS_INFO,
  API_SET_EVENTS_INFO,
  API_SET_GLOBAL_TRIGGERS,
  API_SET_PRIVILLIDGES,
  API_WEBPAGES_SUCCESS
}                                      from '../../constants/API';
import { CAMERAS_SET_CURRENT_STREAMS } from '../../constants/cameras';
import initialState                    from "./initialState";
import {
  APIAction,
  APIState
}                                      from "./types";

const APIReducer = (state: APIState = initialState, action: APIAction) => {

  switch (action.type) {
    case API_AUTH_FETCH :
      return {
        ...state,
        authFetch: !state.authFetch
      };

    case API_AUTH_CERTS_FETCH :
      return {
        ...state,
        authFetch: false,
        authCertsFetch: !state.authCertsFetch
      };

    case API_AUTH_DUO_FETCH:
      return {
        ...state,
        authDuoFetch: !state.authDuoFetch
      }

    case API_SERVICE_TYPE:
      return {
        ...state,
        serviceType: action.serviceType
      }

    case API_AUTH_SET_DUO:
      return {
        ...state,
        duoHost: action.duoHost,
        sigRequest: action.sigRequest
      }

    case API_AUTH_SUCCESS : {
      // @ts-ignore
      window.localStorage.setItem('token', action.token);
      action.token2 && window.localStorage.setItem('token2', action.token2);
      return {
        ...state,
        authFetch: false,
        authSuccess: true,
        username: action.username,
        token: action.token,
        token2: action.token2,
        sessionTokenIsOver: false
      }
    }

    case API_AUTH_ERROR :
      return {
        ...state,
        authFetch: false,
        authCertsFetch: false,
        authErrorMsg: action.msg,
        authErrorTitle: action.title,
        authError: true
      }

    case API_AUTH_DUO_ERROR :
      return {
        ...state,
        authFetch: false,
        authCertsFetch: false,
        authDuoError: true
      }

    case API_AUTH_DUO_SUCCESS :
      return {
        ...state,
        authFetch: false,
        authCertsFetch: false,
        authDuoSuccess: true,
        authError: false
      }

    case API_AUTH_RESET :
      return {
        ...state,
        token: '',
        token2: '',
        authFetch: true,
        authCertsFetch: false,
        authSuccess: false,
        authError: false,
        authServer: false,
        authCerts: false,
        authDuoError: false,
        authDuoSuccess: false,
        authDuoFetch: false,
        duoHost: '',
        sigRequest: '',
        authErrorMsg: '',
        sessionTokenIsOver: false
      };

    case API_AUTH_CERTS_RESET :
      return {
        ...state,
        authFetch: false,
        authCertsFetch: true,
        authSuccess: false,
        authError: false,
        authServer: false,
        authCerts: false,
        authDuoError: false,
        authDuoSuccess: false,
        duoHost: '',
        sigRequest: '',
        authErrorMsg: '',
        sessionTokenIsOver: false
      };

    case API_AUTH_CERTS :
      return {
        ...state,
        authCerts: action.auth,
        authFetch: false,
        authCertsFetch: false
      }

    case API_AUTH_SERVER :
      return {
        ...state,
        authServer: true
      }

    case API_CAMERAS_FETCH :
      return {
        ...state,
        camerasFetch: true,
        camerasSuccess: false,
        camerasError: false
      };

    case API_CAMERAS_SUCCESS : {
      return {
        ...state,
        camerasFetch: false,
        camerasSuccess: true,
        cameras: action.cameras
      };
    }

    case API_MAPS_SUCCESS : {
      return {
        ...state,
        maps: action.maps
      }
    }

    case API_WEBPAGES_SUCCESS : {
      return {
        ...state,
        webPages: action.webPages
      }
    }

    case API_CAMERAS_ERROR :
      return {
        ...state,
        camerasFetch: false,
        camerasError: true
      };

    case API_LAYOUTS_FETCH :
      return {
        ...state,
        layoutsFetch: true,
        layoutsSuccess: false,
        layoutsError: false
      };

    case API_LAYOUTS_SUCCESS :
      return {
        ...state,
        layoutsFetch: false,
        layoutsSuccess: true,
        layouts: action.layouts
      };

    case API_LAYOUTS_ERROR :
      return {
        ...state,
        layoutsFetch: false,
        layoutsError: true
      };

    case API_SET_BOOKMARKS_INFO :
      return {
        ...state,
        bkmsInfo: action.bkmsInfo
      };

    case API_SESSION_TOKEN_IS_OVER :
      return {
        ...state,
        sessionTokenIsOver: true,
      };

    case API_SET_EVENTS_INFO :
      return {
        ...state,
        eventsInfo: action.eventsInfo
      };
    case API_SET_GLOBAL_TRIGGERS :
      return {
        ...state,
        globalTriggers: action.globalTriggers
      };
    case API_SET_PRIVILLIDGES :
      return {
        ...state,
        privileges: action.privileges
      }

    case API_CANCEL_AUTH :
      return {
        ...state,
        authFetch: false,
        authDuoFetch: false
      }

    case 'setMapInfo' : {
      return {
        ...state,
        maps: state.maps.map((el: any) => {
          if (el.id === action.data["a:MapID"]) {
            return {
              ...el,
              bgImg: action.data["a:BackgroundImage"],
              subentities: {
                'a:GeneralEntityInfo': action.data["a:MapElements"]
              }
            }
          }
          return el;
        })
      }
    }

    case 'setWebPageInfo' : {
      return {
        ...state,
        webPages: state.webPages.map((el: any) => {
          if (el.id === action.data["a:EntityID"]) {
            return {
              ...el,
              url: action.data["a:URL"]
            }
          }
          return el;
        })
      }
    }


    case CAMERAS_SET_CURRENT_STREAMS: {
      return {
        ...state,
        cameras: state.cameras.map((cam: any) => {
          return cam.id === action.camId
            ? {
              ...cam,
              currentStream: action.stream
            }
            : cam;
        })
      }
    }

    default:
      return {...state}
  }
};

export default APIReducer